import React from 'react'
import { Box } from '@mui/material'
import { TempNavbar } from '../component/shared/TempNavbar'
import ForgotPasswordForm from '../component/auth/ForgotPasswordForm'
import { Helmet } from 'react-helmet-async'

export const ForgotPasswordScreen = () => {
  return (
    <Box>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Forgot Password</title>
      </Helmet>
      <TempNavbar />
      <ForgotPasswordForm />
    </Box>
  )
}
